import styled from "styled-components";
import { Link } from "react-router-dom";

export const Container = styled.div`
  display: flex;
  ${"" /* margin: 0 84px 0 122px; */}
  height: 70px;
  flex-direction: row;
  padding: 12px 0;
  justify-content: space-between;
  background-color: #d67723;
  @media (max-width: 1000px) {
    margin: 0 0px;
  }

  @media (max-width: 400px) {
    flex-direction: column;
    align-items: center;
    justify-content: unset;
    height: 230px;
  }

  @media (max-width: 350px) {
    flex-direction: column;
    align-items: center;
    justify-content: unset;
    height: 230px;
  }

  @media (max-width: 450px) {
    flex-direction: column;
    align-items: center;
    justify-content: unset;
    height: 230px;
  }

  @media (max-width: 600px) {
    flex-direction: column;
    align-items: center;
    justify-content: unset;
    height: 230px;
  }
`;

export const Text = styled.p`
  margin: 0;
  font-family: NunitoSans-SemiBold;
  font-style: normal;
  font-weight: 600;
  margin: 0 20px 0 20px;
  font-size: 16px;
  letter-spacing: 0.5px;
  margin-top: 20px;
  text-align: left;
  /* white */

  color: #ffffff;
  @media (max-width: 600px) {
    margin-top: 14px;
    text-align: center;
  }
`;

export const SubText = styled.p`
  margin: 0;
  font-family: NunitoSans-SemiBold;
  margin: 0 20px 0 0;
  font-size: 13px;
  letter-spacing: 0.5px;
  color: #ffffff;
`;

export const ButtonLink = styled(Link)`
  z-index: 400;
  display: block;
  cursor: pointer;
  text-decoration: none;
  margin: 0;
  font-family: NunitoSans-SemiBold;
  font-style: normal;
  font-weight: 600;
  margin: 0 20px 0 20px;
  font-size: 16px;
  line-height: 30px;
  letter-spacing: 0.5px;
  margin-top: 20px;

  /* white */

  color: #ffffff;
  @media (max-width: 400px) {
    margin-top: 12px;
  }
`;

export const Logo = styled.img`
  width: 15.75px;
  height: 15.75px;
`;

export const Content = styled.h1`
  display: flex;
  flex-direction: column;
`;
